// Copyright (c) 2025 Deere & Company

import t from 'tcomb';

const RgaAdditionalDataTestParam = t.struct({
    dataParamId: t.String,
    dataType: t.String,
    dataTypeId: t.String,
    paramComments: t.String,
    paramIndex: t.String,
    paramName: t.String,
    paramType: t.String,
    paramValue: t.String,
    rgaNumber: t.String,
    rgaUnit: t.String
}, {
    name: 'RgaAdditionalDataTestParam',
    strict: true
});

export const getDefaultState = () => new RgaAdditionalDataTestParam({
    dataParamId: '',
    dataType: '',
    dataTypeId: '',
    paramComments: '',
    paramIndex: '',
    paramName: '',
    paramType: '',
    paramValue: '',
    rgaNumber: '',
    rgaUnit: ''
});

export default RgaAdditionalDataTestParam;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-additional-data-test-param.js